import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-main">
        <div className="footer-newsletter">
          <h2>Connect</h2>
          <p>goods@denowl.shop</p>
          <p>
            Calle del Oleo Ducto 2423, Las Villas, 67175 Guadalupe, N.L., MX
          </p>
          <div className="social-links">
            <a href="https://www.instagram.com">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.pinterest.com">
              <i className="fab fa-pinterest"></i>
            </a>
            <a href="https://www.facebook.com">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.linkedin.com">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="https://www.youtube.com">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
        <div className="footer-links">
          <div className="link-column">
            <h3>Customer Service</h3>
            <Link onClick={toTop} to="/returns">
              Returns + Exchanges
            </Link>
            <Link onClick={toTop} to="/shipping">
              Shipping + Delivery
            </Link>
          </div>
          <div className="link-column">
            <h3>Inside Denowl</h3>
            <Link onClick={toTop} to="/about">
              About Us
            </Link>
            <Link onClick={toTop} to="/terms">
              Terms of Use
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-legal">
          <p>©2026 Denowl. All Rights Reserved.</p>
          <Link onClick={toTop} to="/privacy">
            Privacy Notice
          </Link>
          <button>Cookie Settings</button>
        </div>
        <div className="footer-collective">
          <p>Part of the MillerKnoll collective</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
